import { render, staticRenderFns } from "./Resizer.vue?vue&type=template&id=4f361fb8&scoped=true&"
import script from "./Resizer.vue?vue&type=script&lang=js&"
export * from "./Resizer.vue?vue&type=script&lang=js&"
import style0 from "./Resizer.vue?vue&type=style&index=0&id=4f361fb8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f361fb8",
  null
  
)

export default component.exports